<ng-template #header>
  <ac-card-header (back)="back.emit()" (close)="close.emit()" />
</ng-template>

@if (pmSyncState() === 'syncing' || coinflowIframeUrl() || !paymentMethods()?.length || this.feesLoading()) {
<ac-card>
  @if (!iframeLoaded() && coinflowIframeUrl()) {
    <ng-container *ngTemplateOutlet="header"></ng-container>
  }
  <ac-card-content>
    <div class="redemption-dialog">
      @if (coinflowIframeUrl()) {
        <iframe
          [style.display]="iframeLoaded() ? 'unset' : 'none'"
          (load)="handleIframeLoad()"
          (error)="handleCoinflowError($event, 'iframe')"
          width="100%"
          height="900px"
          frameborder="0"
          [src]="coinflowIframeUrl()"
        ></iframe>
      }

      @if (!iframeLoaded()) {
        <div class="ac-ctr ac-flex" [style.margin]="'auto'">
          <ac-loading type="spinner" [size]="32" />
        </div>
      }
    </div>
  </ac-card-content>
</ac-card>
} @else {
<ac-card>
  <ng-container *ngTemplateOutlet="header"></ng-container>
  <ac-card-content>
    <div class="redemption-dialog">
      @if (!formComplete() || !paymentMethod()) {
      <app-redemption-dialog-header
        [step]="1"
        title="Bank transfer"
        subtitle="Select a payment method"
        (close)="close.emit()"
        (back)="back.emit()"
      />
      @if (bankAccounts().length) {
      <div class="ac-title-md">Bank Accounts</div>
      <ul class="redemption-dialog__button-list">
        @for (paymentMethod of bankAccounts(); track
        paymentMethod.payment_method_id) {
        <li>
          <button
            class="redemption-dialog__button-list-button"
            (click)="selectPaymentMethod(paymentMethod.payment_method_id)"
          >
            <div class="redemption-dialog__button-list-button-icon">
              <ac-icon [iconKey]="paymentMethod.icon" [size]="32" />
            </div>
            <div class="redemption-dialog__button-list-button-contents">
              <div class="ac-title-md">{{ paymentMethod.name }}</div>
              <div
                class="ac-body-sm redemption-dialog__button-list-button-subtitle"
              >
                Typically {{ paymentMethod.same_day ? '1-3' : '3-5' }} business
                days •
                {{ paymentMethod.fee | currency : 'USD' : 'symbol-narrow' }}
              </div>
            </div>
            <div>
              <ac-icon iconKey="hr:chevron_right" [size]="12" />
            </div>
          </button>
        </li>
        }
      </ul>
      } @if (cards().length) {
      <div class="ac-title-md">Debit Cards</div>
      <ul class="redemption-dialog__button-list">
        @for (paymentMethod of cards(); track paymentMethod.payment_method_id) {
        <li>
          <button
            class="redemption-dialog__button-list-button"
            (click)="selectPaymentMethod(paymentMethod.payment_method_id)"
          >
            <div class="redemption-dialog__button-list-button-icon">
              <ac-icon [iconKey]="paymentMethod.icon" [size]="32" />
            </div>
            <div class="redemption-dialog__button-list-button-contents">
              <div class="ac-title-md">{{ paymentMethod.name }}</div>
              <div
                class="ac-body-sm redemption-dialog__button-list-button-subtitle"
              >
                <ac-icon
                  class="redemption-dialog__bank-fee-instant-icon"
                  iconKey="payment:lightning"
                  [size]="12"
                />
                <span
                  class="redemption-dialog__bank-fee-instant-text"
                  [style.margin-right.px]="4"
                  >Instant transfers</span
                >
                • {{ paymentMethod.fee | currency : 'USD' : 'symbol-narrow' }}
              </div>
            </div>
            <div>
              <ac-icon iconKey="hr:chevron_right" [size]="12" />
            </div>
          </button>
        </li>
        }
      </ul>
      }
      <button
        [loading]="loading() || addPaymentMethodLoading()"
        (click)="addPaymentMethod(); $event.preventDefault()"
        class="ac-btn-lg"
        mat-flat-button
      >
        Connect a different account
      </button>
      } @else {
      <app-redemption-dialog-header
        [step]="2"
        title="Confirm {{
          paymentMethod()?.type === 'bank_account' ? 'ACH' : 'Debit Card'
        }} Redemption"
        subtitle="Please review your redemption details."
        (close)="close.emit()"
        (back)="selectPaymentMethod(null)"
      />

      @if (dailyLimitExceeded()) {
      <div class="ac-just-ctr ac-flex">
        <div class="redemption-dialog__error-box">
          <ac-icon iconKey="payment:warning" [size]="24" />
          <div class="ac-body-sm">
            You've already hit your redemption limit for today.<br />
            You must wait until {{ nextAvailableDate() }} to redeem again.
          </div>
        </div>
      </div>
      }

      <div class="redemption-dialog__button-list-button" [style.width]="'auto'">
        <div class="redemption-dialog__button-list-button-icon">
          <ac-icon [iconKey]="paymentMethod()!.icon" [size]="32" />
        </div>
        <div class="redemption-dialog__button-list-button-contents">
          <div class="ac-title-md">{{ paymentMethod()!.name }}</div>
          <div
            class="ac-body-sm redemption-dialog__button-list-button-subtitle"
          >
            @if (paymentMethod()!.type === 'bank_account') { Typically
            {{ paymentMethod()!.same_day ? '1-3' : '3-5' }} business days •
            {{ paymentMethod()!.fee | currency : 'USD' : 'symbol-narrow' }}
            } @else {
            <ac-icon
              class="redemption-dialog__bank-fee-instant-icon"
              iconKey="payment:lightning"
              [size]="12"
            />
            <span
              class="redemption-dialog__bank-fee-instant-text"
              [style.margin-right.px]="4"
              >Instant transfers</span
            >
            • {{ paymentMethod()!.fee | currency : 'USD' : 'symbol-narrow' }}
            }
          </div>
        </div>
      </div>

      <ul class="redemption-dialog__crypto-confirm-table ac-body-md">
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Amount</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>{{ amount() | currency : 'USD' : 'symbol-narrow' }}</div>
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Transfer Fee
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ paymentMethod()!.fee | currency : 'USD' : 'symbol-narrow' }}
            </div>
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Total Redemption
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ totalRedemptionAmount() | currency : 'USD' : 'symbol-narrow' }}
            </div>
          </div>
        </li>
      </ul>

      <button
        [disabled]="
          this.paymentMethodId.invalid ||
          dailyLimitExceeded() ||
          hasPlaythroughRequirement()
        "
        [loading]="loading()"
        class="ac-btn-lg"
        (click)="submit(); $event.preventDefault()"
        mat-flat-button
      >
        Redeem
        {{ totalRedemptionAmount() | currency : 'USD' : 'symbol-narrow' }}
      </button>
      } @if (hasPlaythroughRequirement()) {
      <div class="redemption-dialog__footer ac-body-sm text-warning">
        Due to a recent purchase, your Playthrough Requirement has changed.
        Please refresh the page.
      </div>
      }
      <div class="redemption-dialog__footer">
        <div class="redemption-dialog__footer-text">
          @if (formComplete()) { @if (paymentMethod()!.type === 'bank_account')
          { Redemptions to a bank account have a
          {{ paymentMethod()!.fee | currency : 'USD' : 'symbol-narrow' }} fee
          that is deducted from the requested amount. It may take up to
          {{ paymentMethod()!.same_day ? '3' : '5' }} business days to transfer.
          } @else { Redemptions to a debit card have a
          {{ paymentMethod()!.fee | currency : 'USD' : 'symbol-narrow' }} fee
          that is deducted from the requested amount and typically take 30
          minutes but may take longer depending on your bank. } }
        </div>
      </div>
    </div>
  </ac-card-content>
</ac-card>
}
